<template>
  <select
    v-model="hotelQty"
    class="select required inline quantity form-control"
    @change="emitQty()"
  >
    <option
      v-for="n in hotelMaxQty"
      :key="n"
      :value="n"
    >
      {{ n }}
    </option>
  </select>
</template>

<script>
export default {
  props: {
    hotelMaxQty: {
      default: 1,
      required: true,
      type: Number
    },

    qty: {
      default: 1,
      required: true,
      type: Number
    }
  },

  data() {
    return {
      hotelQty: 1,
    }
  },

  watch: {
    qty() {
      this.hotelQty = this.qty
    }
  },

  methods: {
    emitQty() {
      this.$emit('qty-change', this.hotelQty)
    }
  }
}
</script>
